import PropTypes from "prop-types";
import ChevronRight from "../../../../images/Chevron_Right.svg";
import useStyles from "./template-item-icons.styles";
import { AdapterIcon } from "../../../../../../../../generic/icon/component-icon/component-icon";

const TemplateItemIcons = ({ fromIcon, toIcon }) => {
    const classes = useStyles();
    const SourceIcon = typeof fromIcon === "string" ? null : fromIcon;
    const TargetIcon = typeof toIcon === "string" ? null : toIcon;

    const getTargetIcon = toIcon => {
        return TargetIcon ? (
            <TargetIcon className={classes.elementIcon} />
        ) : (
            <AdapterIcon size={42} useNative name={toIcon} />
        );
    };

    return (
        <>
            {fromIcon &&
                (SourceIcon ? (
                    <SourceIcon className={classes.elementIcon} />
                ) : (
                    <AdapterIcon size={42} useNative name={fromIcon} />
                ))}
            {fromIcon && toIcon && <ChevronRight className={classes.forwardIcon} />}
            {toIcon && getTargetIcon(toIcon)}
        </>
    );
};

TemplateItemIcons.propTypes = {
    fromIcon: PropTypes.oneOfType([PropTypes.string, PropTypes.elementType]),
    toIcon: PropTypes.oneOfType([PropTypes.string, PropTypes.elementType])
};

export default TemplateItemIcons;
